const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeCounting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.686,
    height: 26.686,
    viewBox: "0 0 26.686 26.686",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 13.343,
    cy: 13.343,
    r: 12.343,
    fill: "none",
    stroke: "#000000",
    strokeDashoffset: 11.411,
    strokeLinejoin: "round",
    strokeWidth: 2,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.3203,
    cy: 12.23,
    r: 1.9158,
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.644,
    cy: 9.2103,
    r: 1.9158,
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.126,
    cy: 16.192,
    r: 1.9158,
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.556,
    cy: 17.627,
    r: 1.9158,
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      paintOrder: "stroke markers fill"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeCounting);
export default __webpack_public_path__ + "static/media/icon_type_counting.bb03759334ab4bf83062537ec23f4d7b.svg";
export { ForwardRef as ReactComponent };